export * from './NftDetails';
